import { joinFormIdAndSelector } from './add-file-utils';

export const ADD_CLIENT_FORM_SELECTOR = '#addClientForm';

export const getCompanySelector = (formIdSelector: string = ADD_CLIENT_FORM_SELECTOR) => {
    return `${formIdSelector} #select-company`;
};

export const getBranchSelector = (formIdSelector: string = ADD_CLIENT_FORM_SELECTOR) => {
    return `${formIdSelector} #select-branch`;
};

export const getWireDocSelector = (formIdSelector: string = ADD_CLIENT_FORM_SELECTOR) => {
    return joinFormIdAndSelector(formIdSelector, 'wireDoc_id');
};

export const REQUEST_BANK_INFO_NAME = 'requestBankInfo_recipients[]';
export const REQUEST_BANK_INFO_SELECTOR = `input[name="${REQUEST_BANK_INFO_NAME}"]`;

export const REQUEST_IDV_NAME = 'requestIdVerification_recipients[]';
export const REQUEST_IDV_SELECTOR = `input[name="${REQUEST_IDV_NAME}"]`;

export const WIRE_DOC_RECIPIENTS_NAME = 'wireDoc_recipients[]';
export const WIRE_DOC_RECIPIENTS_SELECTOR = `input[name="${WIRE_DOC_RECIPIENTS_NAME}"]`;

export type ClientMultiSelectName = typeof REQUEST_BANK_INFO_NAME | typeof REQUEST_IDV_NAME | typeof WIRE_DOC_RECIPIENTS_NAME;

export const getWireDocRecipientsSelector = (formIdSelector: string = ADD_CLIENT_FORM_SELECTOR) => {
    return joinFormIdAndSelector(formIdSelector, 'wireDoc_recipients');
};
